

$(document).ready(function() {
    var div = $(".b-modal-social");

    $("#js-social").click(function(){
        $('.b-modal-social').toggleClass("active");
    });

    $(document).mouseup(function (e){ 
        if (!div.is(e.target) && div.has(e.target).length === 0) { 
            div.removeClass("active")
        }
    });

    $(".js-close-social").click(function(){
        div.removeClass("active")
    });
});


// WEBPACK FOOTER //
// ./src/js/general/modal-social.js